import { RouteConfig } from 'vue-router'
import {AuthGuard} from "@/router/types";

export const defaultRoute: RouteConfig = {
    path: '*', redirect: '/',
    meta: {
        requiresAuth: AuthGuard.CANNOT_BE_AUTHENTICATED
    }
}